import React from 'react';
import { ArrowDownUpIcon, Loader2Icon } from 'lucide-react';

const SwapButton = ({ 
  isConnected, 
  onConnect, 
  canSwap, 
  onSwap, 
  isSwapping, 
  swapError,
  fromToken,
  toToken,
  fromAmount,
  estimatedOutput
}) => {
  
  // Not connected to wallet
  if (!isConnected) {
    return (
      <button
        onClick={onConnect}
        className="w-full py-4 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-[1.02] hover:shadow-lg font-orbitron"
      >
        Connect Wallet
      </button>
    );
  }

  // Show error state
  if (swapError) {
    return (
      <button
        disabled
        className="w-full py-4 bg-red-500/20 border border-red-400/50 text-red-300 font-semibold rounded-xl cursor-not-allowed"
      >
        {swapError}
      </button>
    );
  }

  // Swapping in progress
  if (isSwapping) {
    return (
      <button
        disabled
        className="w-full py-4 bg-blue-500/20 border border-blue-400/50 text-blue-300 font-semibold rounded-xl cursor-not-allowed flex items-center justify-center space-x-2"
      >
        <Loader2Icon className="w-5 h-5 animate-spin" />
        <span>Swapping...</span>
      </button>
    );
  }

  // Cannot swap (missing inputs, insufficient balance, etc.)
  if (!canSwap) {
    let buttonText = 'Enter Amount';
    
    if (!fromToken) {
      buttonText = 'Select Input Token';
    } else if (!toToken) {
      buttonText = 'Select Output Token';
    } else if (!fromAmount || fromAmount === '0') {
      buttonText = 'Enter Amount';
    } else if (fromToken.address === toToken.address) {
      buttonText = 'Select Different Tokens';
    }

    return (
      <button
        disabled
        className="w-full py-4 bg-white/5 border border-white/10 text-white/50 font-semibold rounded-xl cursor-not-allowed"
      >
        {buttonText}
      </button>
    );
  }

  // Ready to swap
  return (
    <button
      onClick={onSwap}
      className="w-full py-4 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-[1.02] hover:shadow-lg flex items-center justify-center space-x-2 font-orbitron"
    >
      <ArrowDownUpIcon className="w-5 h-5" />
      <span>
        Swap {fromToken?.symbol} to {toToken?.symbol}
      </span>
    </button>
  );
};

export default SwapButton;